module.exports = __webpack_public_path__ + "static/pool2-d9c8850e920a106af6b13f77bed2afcc.jpg";